import { useNavigate } from "@shopify/hydrogen";
import { useEffect, useState} from "react";
import RemoveIcon from "~/assets/icons/RemoveIcon";
import { getQuote } from "~/lib/utils";
import { CustomizeProduct, ProductMetafields, VariantEdgeMetafields } from "~/types";
import { quote } from "../../../../setup/settings/index";

export default function QuoteButton({ remove, price, show, product, indexRemove, disabled, optionsSelected, customizeOptions, close }: { remove?: () => void, price: number, show: boolean, indexRemove?: number, variant?: VariantEdgeMetafields, variantId: string, variants: VariantEdgeMetafields[], product: ProductMetafields, disabled?: boolean, customizeOptions: CustomizeProduct[], close: () => void }) {

    const [exist, setExist] = useState();

    if (!quote.enabled) return (<></>)
    useEffect(() => {
        const quote = getQuote();
        const equals = quote.filter(q => q.product.handle == product.handle);
        if (equals.length > 0) {
            setExist(true);
        }
        else {
            setExist(false);
        }
    }, [show])

    const navigate = useNavigate();

    const onClick = () => {

        if (disabled && !exist) return

        if (exist) {
            const quote = getQuote();

            const productQuote = quote.filter(q => q.product.handle == product.handle);
            if (productQuote[0].options) {
                let index = -1;
                quote.forEach((q, i) => {
                    if (q.product.handle == product.handle) {
                        let same = true;
                        optionsSelected.forEach(os => {
                            const qoption = q.options.find(qo => qo.Id == os.Id);
                            if (qoption.option.Id == os.option.Id) same = same && true;
                            else same = false;
                        });
                        if (same) index = i;
                    }
                })
                quote.splice(index, 1);
                window.localStorage.setItem('quote', JSON.stringify(quote))
            }
            else {
                const newQuote = quote.filter(q => q.product.handle != product.handle);
                window.localStorage.setItem('quote', JSON.stringify(newQuote))
            }
        }
        else {
            if (optionsSelected && customizeOptions) {
                const options = optionsSelected.map(os => {
                    const opt = customizeOptions.filter(co => co.Id == os.Id || co.Title == os.Title)[0];
                    return {
                        title: opt.Title,
                        ...os
                    }
                })
                const quote = getQuote()
                quote.push({ product, options, price });
                window.localStorage.setItem('quote', JSON.stringify(quote));
                navigate("page/quote");
            }
            else {
                const quote = getQuote();
                quote.push({ product });
                window.localStorage.setItem('quote', JSON.stringify(quote));
                navigate("page/quote");
            }
        }

        if (close) close();
        else {
            const quote = getQuote();
            const equals = quote.filter(q => q.product.handle == product.handle);
            if (equals.length > 0) {
                setExist(true);
            }
            else {
                setExist(false);
            }
        }
    }

    useEffect(() => {
        const quote = getQuote();
        const equals = quote.filter(q => q.product.handle == product.handle);
        if (equals.length > 0) {
            if (optionsSelected) {
                let existCustomizable = undefined;
                optionsSelected.forEach(os => {
                    if (!existCustomizable) existCustomizable = true;
                    existCustomizable = existCustomizable && equals.some(q => q.options.find(o => o.Id == os.Id && o.option.Id == os.option.Id));
                })
                if (optionsSelected.length != customizeOptions.length) existCustomizable = false;
                if (!existCustomizable) existCustomizable = false;
                setExist(existCustomizable);
            }
            else setExist(true);
        }
        else {
            setExist(false);
        }
    }, [])

    const removeProduct = () => {
        const quote = getQuote();
        if (!Number.isNaN(indexRemove)) {
            quote.splice(indexRemove, 1);
            window.localStorage.setItem('quote', JSON.stringify(quote))
            remove && remove();
        }
    }

    if (remove) return (
        <RemoveIcon aria-hidden="true" onClick={removeProduct} />
    )
    else return (
        <div onClick={onClick} className={`quote-button ${disabled && !exist && 'disabled'}`}>{exist ? 'Remove from Quote' : 'Add to Quote'}</div>
    )
}